<script>
    import MultipleSelector from '@/components/Form/MultipleSelector.vue'

    export default {
        name : 'channel-selector',
        extends: MultipleSelector,
        methods: {
            buildOptions: function (channels) {
                let options = [];
                for (let key in channels) {
                    let option = {};
                    option['id'] = channels[key]['id'];
                    option['name'] = channels[key]['nombre'] + ' (' + channels[key]['tipo'] + ')';
                    options.push(option);
                }
                return options;
            },
            initChannels () {
                fetch('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_web_json/MarketingCampaignChannels/list')
                    .then(response => response.json())
                    .then(data => {
                        if (data.result) {
                            this.options = this.buildOptions(data.data);
                        } else {
                            this.emitError();
                        }
                    }).catch(() => {
                        this.emitError();
                    })
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar los canales.");
            }
        },
        created () {
            this.initChannels ();
        }
    }
</script>